// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__1v-M3","paramInput":"JobSimulator_paramInput__3roh-","input":"JobSimulator_input__3ZS9i"};